<div class="m-2">
  <img class="claimedBenefit" width="100" height="100" src="{{ benefit.ImageFileName | contentImage: '1' }}" />
</div>
